<h1 mat-dialog-title>{{displayname}}</h1>
<mat-dialog-content>

  <div class="help-container">

    <div class="doc-container">
      <ng-container *ngIf="op_description !== undefined">
      <h2>Description: </h2>
  	  <p>{{op_description}}</p>
     </ng-container>

     <ng-container *ngIf="op_application!== undefined">
      <h2>Application: </h2>
  	  <p>{{op_application}}</p>
      </ng-container>

      <div class="params">
        <ng-container *ngIf="data.op.params.length > 0"><h2> Parameters: </h2></ng-container>
        <ng-container *ngFor="let param of data.op.params; index as i">
            <h3>{{param.name}}</h3>
            <p>{{param_descriptions[i]}}</p>
            <p>Type: {{param.type}}</p> 
            <p *ngIf="param.type == number"> min/max value of this input: {{param.min}}-{{param.max}}</p>
		    </ng-container>

        <ng-container *ngIf="is_dynamic_op">
          <h4>This is a dyanmic operation, meaning that one of the parameters above generates multiple "inlets" to the function, each which can accept a draft and associate a particular value with that draft.</h4>
          <h3>Input that Controls the Inlets: {{dynamic_param_name}}</h3>
          <p>Inlet type: {{dynamic_type}}</p>
      </ng-container>

      <ng-container *ngIf="youtube !== undefined">
        {{youtube}}
        <iframe width="560" height="315" [src]="youtube" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </ng-container>


      </div>


      <!-- <div id="docs" [innerHTML]="documentation"></div>
      <h2>Documentation</h2> -->
    
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="mat-raised-button mat-primary"(click)="close()">Close</button>
</mat-dialog-actions>